import React from 'react';
import {Link} from 'react-router-dom';
import {Cell} from '../components/Cell/index';

export const cellRenderers: any = {
    __tags: (id: any) => (
        <Cell key={id}
              content={''}
              classNames={`cell-${id} cell-id`}
        />
    ),
    parent_entry_id: (id: any, value: any) => (
        <Cell
            key={id}
            content={
                <Link to={`/entry/${value}`}
                      onClick={(e) => {
                          e.stopPropagation();
                      }}
                >{value}</Link>
            }
            classNames={`cell-${id} cell-id`}
        />
    ),
    id: (id: any, value: any) => (
        <Cell
            key={id}
            content={
                <Link to={`/entry/${value}`}
                      onClick={(e) => {
                          e.stopPropagation();
                      }}
                >{value}</Link>
            }
            classNames={`cell-${id} cell-id`}
        />
    ),
    workflow_step_assignees: (id: any, value: any) => (
        <Cell
            key={id}
            content={
                <div dangerouslySetInnerHTML={{__html: value}} />
            }
            classNames={`cell-${id} cell-workflow_step_assignees`}
        />
    ),
    created_by_on_date: (id: any, value: any) => (
        <Cell
            key={id}
            content={
                <div dangerouslySetInnerHTML={{__html: value}}/>
            }
            classNames={`cell-${id} cell-created_by_on_date`}
        />
    ),
};